

class Module13Map {
    constructor() {
        let scrollPos = 0;
        let cache = {};
        let initFunc = () => {
            initCache();
            registerEvents();
        }

        let initCache = () => {
            cache.maps = document.querySelectorAll('.google-map');
        }

        let registerEvents = () => {
            cache.maps.forEach(map => {
                initMap(map);
            });
        }

        let initMap = function(el) {
            const styleMap =[
                {
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "visibility": "off"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "elementType": "labels.text.stroke",
                  "stylers": [
                    {
                      "color": "#f5f5f5"
                    }
                  ]
                },
                {
                  "featureType": "administrative.land_parcel",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#bdbdbd"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "poi",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "poi.park",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#ffffff"
                    }
                  ]
                },
                {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#757575"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#dadada"
                    }
                  ]
                },
                {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#616161"
                    }
                  ]
                },
                {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                },
                {
                  "featureType": "transit.line",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#e5e5e5"
                    }
                  ]
                },
                {
                  "featureType": "transit.station",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#eeeeee"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "geometry",
                  "stylers": [
                    {
                      "color": "#c9c9c9"
                    }
                  ]
                },
                {
                  "featureType": "water",
                  "elementType": "labels.text.fill",
                  "stylers": [
                    {
                      "color": "#9e9e9e"
                    }
                  ]
                }
              ];
      
            let marker = el.querySelector('.marker');
      
            let mapArgs = {
              zoom        : parseInt(el.dataset.zoom) || 16,
              mapTypeId   : google.maps.MapTypeId.ROADMAP,
              styles      : styleMap,
              disableDefaultUI: true,
            };
            let map = new google.maps.Map( el, mapArgs );
      
            map.markers = [];
            initMarker( marker, map );
            centerMap( map );
            
            return map;
          }
            

          function initMarker( marker, map ) {

            // Get position from marker.
            let lat = marker.dataset.lat;
            let lng = marker.dataset.lng;
            let latLng = {
                lat: parseFloat( lat ),
                lng: parseFloat( lng )
            };
      
            // Create marker instance.
            let pin = new google.maps.Marker({
                position : latLng,
                map: map,
                icon: {
                  fillColor: '#00FF00',
              },
            });
      
            // const pinViewBackground = new google.maps.marker.PinView({
            //   background: '#FBBC04',
            // });
            // const pin = new google.maps.marker.AdvancedMarkerView({
            //     map,
            //     position : latLng,
            //     content: pinViewBackground.element,
            // });
      
            // Append to reference for later use.
            map.markers.push( pin );
      
            // If marker contains HTML, add it to an infoWindow.
            if( marker.html ){
      
                // Create info window.
                let infowindow = new google.maps.InfoWindow({
                    content: marker.html()
                });
      
                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open( map, marker );
                });
            }
        }
      
        function centerMap( map ) {
          
            let bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function( marker ){
            
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });
      
            // Case: Single marker.
            if( map.markers.length == 1 ){
                map.setCenter( bounds.getCenter() );
      
            // Case: Multiple markers.
            } else{
                map.fitBounds( bounds );
            }
        }
        initFunc();
    }
}

export { Module13Map }